import { IErrorMessage } from "../core/contracts/IErrorMessage";

export interface WmsCapabilities extends IErrorMessage {
    mapName?: string;
    layers?: WmsLayer[];
    serviceLayerName?: string;
}
export interface WmsLayer {
    name: string;
    title: string;
    nodes?: GetLegendGraphicNode;
}
export interface WmsCapabilitiesResponse extends IErrorMessage {
    capabilities?: WmsCapabilities;
}
export interface GetWmsCapabilitiesRequest {
    url?: string | null;
}
export interface GetFeatureInfoRequest {
    url: string | null;
    layers: string[];
    x: number;
    y: number;
    width: number;
    height: number;
    easting: number;
    northing: number;
}
export interface GetLegendGraphicRequest {
    layer: string;
}
export interface GetLegendGraphicResponse extends IErrorMessage {
    nodes: GetLegendGraphicNode[];
    title: string;
}
export interface GetLegendGraphicNode {
    type: string;
    title: string;
    icon?: string;
    name?: `${typeof STATMAP_PREFIX}${string}`;
    nodes?: GetLegendGraphicNode[];
    symbols?: GetLegendGraphicNode[];
}
export const STATMAP_PREFIX = "statmap:" as const;
export type GetFeatureInfoResponse = any;
